import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, Box } from '@mui/material';

import { fetchDefaultFeedbackMessages } from '../../../modules/reports/thunks';

const SubmitFeedbackButton = ({
  setIsOpenFeedbackModal,
  houseRef,
  setIsButtonClickType,
  setLoadingFeedbackModalData,
  selectedLotsForDisputes
}) => {
  const dispatch = useDispatch();
  const handleLeaveFeedbackOnSelected = () => {
    setLoadingFeedbackModalData(true);
    setIsOpenFeedbackModal(true);
    dispatch(fetchDefaultFeedbackMessages(houseRef, setLoadingFeedbackModalData, true));
    setIsButtonClickType('button');
  };

  return (
    <Box>
      <Button
        variant="contained"
        color="primary"
        className="cursor-not-allowed placeBidbutton"
        disabled={!selectedLotsForDisputes.length}
        onClick={handleLeaveFeedbackOnSelected}
      >
        <span>Leave Feedback on Selected {selectedLotsForDisputes.length > 0 && `(${selectedLotsForDisputes.length})`}</span>
      </Button>
    </Box>
  );
};

export default SubmitFeedbackButton;
